module.exports = __webpack_public_path__ + "img/partnerYingSer.04e0f159.png";